import { stopBubbling } from '@Utils/helpers/eventHelpers';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/EditOutlined';
import { IconButton, TableCell, TableRow, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { IProject } from '@Data/projects/Interfaces';
import Styles from './ProjectsList.scss';

interface IProjectsListRowProps {
    onClick: (project: IProject) => void;
    project: IProject;
    onEditProjectName: (project: IProject) => void;
    onDelete: (event: React.MouseEvent, project: IProject) => void;
    trStyle: React.CSSProperties;
}

const ProjectsListRow = (props: IProjectsListRowProps) => {
    const { onClick, onEditProjectName, onDelete, project, trStyle } = props;

    const iconCellStyle = { width: 50 };

    const handleIconClick = (event: React.MouseEvent) => {
        stopBubbling(event);
        onEditProjectName(project);
    };

    return (
        <TableRow style={trStyle} onClick={() => onClick(project)}>
            <TableCell>
                <span className={Styles.plName}>{project.project_name}</span>
            </TableCell>
            <TableCell style={iconCellStyle}>
                <IconButton onClick={handleIconClick}>
                    <Tooltip title={`Edit Project Name`}>
                        <EditIcon />
                    </Tooltip>
                </IconButton>
            </TableCell>
            <TableCell style={iconCellStyle}>
                <IconButton
                    onClick={(e) => {
                        onDelete(e, project);
                    }}
                >
                    <Tooltip title={`Delete ${project.project_name}`}>
                        <DeleteIcon />
                    </Tooltip>
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

ProjectsListRow.propTypes = {
    onClick: PropTypes.func,
    onEditProjectName: PropTypes.func,
    onDelete: PropTypes.func,
    project: PropTypes.object,
    trStyle: PropTypes.object,
};
export default ProjectsListRow;
